// extracted by mini-css-extract-plugin
module.exports = {"status":"Status_status__1LWe8 round bold"};